module.exports = "/_next/static/images/a8c599e2b4e73bafd8d7dacec2a85ec8-image-left-xs.jpg";